import { capitalizeFirst } from "../utils";

const emptyRequest = () => ({
  req: null,
  url: null,
  params: null,
  body: null,
});

const getRequest = (url, params = {}) => ({
  req: "GET",
  url,
  params,
  body: null,
});

const postRequest = (url, body, params = {}) => ({
  req: "POST",
  url,
  params,
  body,
});

const deleteRequest = (url, id, params = {}) => ({
  req: "DELETE",
  url: `${url}/eliminar`,
  params: {
    ...params,
    [`id${capitalizeFirst(url)}`]: id,
  },
});

const enableRequest = (url, id, params = {}) => ({
  req: "DELETE",
  url: `${url}/habilitar`,
  params: {
    ...params,
    [`id${capitalizeFirst(url)}`]: id,
  },
});

export { emptyRequest, getRequest, postRequest, deleteRequest,enableRequest };
